var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAddressBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.89274 14H10.1073C12.4357 14 14 12.3635 14 9.92821V4.07253C14 1.63653 12.4357 0 10.108 0H3.89274C1.56432 0 0 1.63653 0 4.07253V9.92821C0 12.3635 1.56432 14 3.89274 14Z",
    fill: "#1080FF",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.0957 9.08958V2.56676C4.0957 2.15981 4.42559 1.82992 4.83254 1.82992L9.15902 1.82983C9.56597 1.82983 9.89586 2.15965 9.89586 2.56656L9.89689 9.08774C9.89689 9.66373 9.2554 9.89001 8.75479 9.60389L7.00412 8.60326L5.23605 9.60691C4.73477 9.88935 4.0957 9.66586 4.0957 9.08958Z",
    fill: "#1080FF",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddressBook);
export default __webpack_public_path__ + "static/media/IC_address_book.b5f2dbea.svg";
export { ForwardRef as ReactComponent };